import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { increment, decrement } from './actions';
import { selectCount } from './selectors';
import CounterInput from '../../components/CounterInput';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

/**
 * Container para el counter de ejemplo
 *
 * @class CounterPage
 * @extends {React.Component}
 */
class CounterPage extends React.Component {
    componentWillMount() {

    }

    render() {
        const { count, actions } = this.props;

        return (
            <div className="counter-page">
                <h1>
                  Counter Page!
                </h1>
                <CounterInput
                  count={count}
                  onClickDecrement={actions.decrement}
                  onClickIncrement={actions.increment}
                />
            </div>
        );
    }
}

CounterPage.defaultProps = {
    count: 0
};

CounterPage.propTypes = {
    actions: PropTypes.object.isRequired,
    count: PropTypes.number
};

const mapStateToProps = (state) => ({
    count: selectCount(state)
  });

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ increment, decrement }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CounterPage);



// WEBPACK FOOTER //
// ./src/containers/CounterPage/index.js